import { RangeDatepicker } from "chakra-dayzed-datepicker";
export default function AppDatePicker(props) {
  const { selectedDates, onDateChange } = props;
  return (
    <>
      <RangeDatepicker
        selectedDates={selectedDates}
        onDateChange={onDateChange}
        configs={{
          dateFormat: 'dd/MM/yyyy',
        }}
        propsConfigs={{
          triggerBtnProps: {
            borderColor: "#dfe4ea",
            color: "black",
            borderRadius: "5px",
            background: "white",
            height:"45px",
            _hover: {
                background: "white",
              },
          },
          dayOfMonthBtnProps: {
            defaultBtnProps: {
              borderRadius: "10px",
              borderColor: "#e33621",
              _hover: {
                background: "#02ad02",
              },
            },
            isInRangeBtnProps: {
              background: "#e33621",
              color: "white",
            },
            selectedBtnProps: {
              background: "#e33621",
              color: "white",
              borderRadius: "10px",
            },
            todayBtnProps: {
              background: "#02ad02",
              color: "white",
            },
          },
          inputProps: {
            size: "sm",
            borderColor: "red",
          },
        }}
      />
    </>
  );
}
